import { Route } from 'react-router-dom'

import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'
import AccessPointZones  from './AccessPointZones'
import React from 'react'

const Layout = () => {
  return (
    <RouteGuard requiredRoles={['access_point_zones']}>
      <AccessPointZones />
    </RouteGuard>
  )
}

const Routes = () => [
  <Route path="access-point-zones" key="access-point-zones" element={<Layout />} />
]

export default Routes